import { render, staticRenderFns } from "./ManagementFeeList.vue?vue&type=template&id=555d9a54&scoped=true"
import script from "./ManagementFeeList.vue?vue&type=script&lang=js"
export * from "./ManagementFeeList.vue?vue&type=script&lang=js"
import style0 from "./ManagementFeeList.vue?vue&type=style&index=0&id=555d9a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555d9a54",
  null
  
)

export default component.exports